export default "__VITE_ASSET__DpgGUBx1__"